module.exports = __webpack_public_path__ + "static/media/placeshareThumbnail.54553a8b.png";